import { TICKET_CATEGORIES, type TicketCategory } from '../../types/bpTickets';
import { SELECT_CHEVRON } from './chevron';

/**
 * A chip-styled `<select>` for Category — the same "the display doubles as the control" pattern
 * as StatusSelect, generalized to a plain closed enum with no per-value colour (CategoryBadge is
 * always the neutral grey chip, so this is too). A plain native select rather than the
 * design-system Select atom for the same reason as StatusSelect: the DS trigger has its own fixed
 * padding/chrome and cannot be shaped into a small inline colour chip.
 */
export function CategorySelect({
  category,
  onChange,
  disabled,
}: {
  category: TicketCategory | null;
  onChange: (category: TicketCategory) => void;
  disabled?: boolean;
}) {
  // A category Airtable no longer has, or none on file, is still shown rather than silently
  // jumping to the first option in the list — same reasoning as StatusSelect's unknown-status case.
  const options = category && TICKET_CATEGORIES.includes(category) ? TICKET_CATEGORIES : [category, ...TICKET_CATEGORIES];
  return (
    <select
      value={category ?? ''}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as TicketCategory)}
      style={{ backgroundImage: SELECT_CHEVRON, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 8px center', backgroundSize: '10px' }}
      className="appearance-none rounded bg-pearl py-0.5 pl-2 pr-6 text-xs font-regular text-iron disabled:opacity-60"
    >
      {options.map((c) => (
        <option key={c ?? ''} value={c ?? ''}>
          {c ?? 'No category'}
        </option>
      ))}
    </select>
  );
}
